import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from '../services/apiClient';
import { getLocalItem, getSessionItem } from '../utils/safeStorage';

const base = '/api/admin/cabs';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    qs.set(key, String(value));
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

export const listHeroBanners = (params) => apiGet(`${base}/hero-banners${buildQuery(params)}`);
export const createHeroBanner = (payload) => apiPost(`${base}/hero-banners`, payload);
export const updateHeroBanner = (id, payload) => apiPut(`${base}/hero-banners/${id}`, payload);
export const toggleHeroBanner = (id, isActive) => apiPatch(`${base}/hero-banners/${id}/status`, { isActive });
export const deleteHeroBanner = (id) => apiDelete(`${base}/hero-banners/${id}`);

export const listVehicleBanners = (params) => apiGet(`${base}/vehicle-banners${buildQuery(params)}`);
export const createVehicleBanner = (payload) => apiPost(`${base}/vehicle-banners`, payload);
export const updateVehicleBanner = (id, payload) => apiPut(`${base}/vehicle-banners/${id}`, payload);
export const toggleVehicleBanner = (id, isActive) => apiPatch(`${base}/vehicle-banners/${id}/status`, { isActive });
export const deleteVehicleBanner = (id) => apiDelete(`${base}/vehicle-banners/${id}`);

export const listGuestTripsAdmin = (params) => apiGet(`${base}/guest-trips${buildQuery(params)}`);
export const createGuestTrip = (payload) => apiPost(`${base}/guest-trips`, payload);
export const updateGuestTrip = (id, payload) => apiPut(`${base}/guest-trips/${id}`, payload);
export const toggleGuestTrip = (id, isActive) => apiPatch(`${base}/guest-trips/${id}/status`, { isActive });
export const deleteGuestTrip = (id) => apiDelete(`${base}/guest-trips/${id}`);

export const listBlogsAdmin = (params) => apiGet(`${base}/blogs${buildQuery(params)}`);
export const createBlog = (payload) => apiPost(`${base}/blogs`, payload);
export const updateBlog = (id, payload) => apiPut(`${base}/blogs/${id}`, payload);
export const toggleBlog = (id, isActive) => apiPatch(`${base}/blogs/${id}/status`, { isActive });
export const deleteBlog = (id) => apiDelete(`${base}/blogs/${id}`);

export const listPromoVideosAdmin = (params) => apiGet(`${base}/promo-videos${buildQuery(params)}`);
export const createPromoVideo = (payload) => apiPost(`${base}/promo-videos`, payload);
export const updatePromoVideo = (id, payload) => apiPut(`${base}/promo-videos/${id}`, payload);
export const togglePromoVideo = (id, isActive) => apiPatch(`${base}/promo-videos/${id}/status`, { isActive });
export const deletePromoVideo = (id) => apiDelete(`${base}/promo-videos/${id}`);

export const getFooterConfigAdmin = () => apiGet(`${base}/footer`);
export const updateFooterConfigAdmin = (payload) => apiPut(`${base}/footer`, payload);

export const uploadAdminAsset = async (fileOrUrl) => {
  const form = new FormData();
  if (fileOrUrl instanceof File) {
    form.append('file', fileOrUrl);
  } else if (typeof fileOrUrl === 'string') {
    form.append('url', fileOrUrl);
  }
  const token = getSessionItem('adminAccessToken') || getLocalItem('adminAccessToken') || '';
  const res = await fetch(`${process.env.REACT_APP_API_BASE_URL || ''}/api/admin/uploads`, {
    method: 'POST',
    credentials: 'include',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    body: form,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || 'Upload failed');
  return data;
};


